import React, { useMemo } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface IVersionNameField {
	changeVersionName: (value: string) => void;
}

export const VersionNameField: React.FC<IVersionNameField> = React.memo(({ changeVersionName }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterVersionName') },
			{ max: 50, message: tForm('fieldCannotBeMoreThanCharactersLong', { count: 50 }) },
		],
		[t],
	);

	return (
		<FormInput
			testId="VersionNameField"
			name="versionName"
			label="versionNameLabel"
			onChange={changeVersionName}
			validationRules={validationRules}
		/>
	);
});
